module.exports = __webpack_public_path__ + "static/media/subICloud1.a2ca5a75.png";